import I18n from 'I18n';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FriendlySenderName = ({
  channelName,
  isNamedUnknownVisitor,
  senderName,
  isLoading
}) => {
  const showUnknownVisitorTooltip = isNamedUnknownVisitor && senderName && channelName;
  if (isLoading) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [senderName, showUnknownVisitorTooltip && /*#__PURE__*/_jsx(HelpIcon, {
      "data-test-id": "unknown-visitor-tooltip-icon",
      alignWithText: true,
      marginInlineStart: "100",
      color: "text-core-default",
      title: I18n.text('conversations-inbox-message-history.common-message.sender.unknownNamedVisitorTooltip', {
        integratorName: channelName
      })
    })]
  });
};
FriendlySenderName.displayName = 'FriendlySenderName';